import React, { useState, SetStateAction, useEffect } from 'react';
import { Grid, Typography, Box, InputLabel } from '@material-ui/core';
import { useStyles } from './styles';
import { InfractionsVehicles } from '../../@types/records';

interface IProps {
  infractionsVehicles: InfractionsVehicles;
  setInfractionsVehicles: React.Dispatch<SetStateAction<InfractionsVehicles>>;
}

const InfrVehiclesFormGroup: React.FC<IProps> = ({
  infractionsVehicles,
  setInfractionsVehicles,
}) => {
  const classes = useStyles();
  const [infractionsState, setInfractionsState] = useState<InfractionsVehicles>(
    infractionsVehicles,
  );

  const handleChange = (key: string, value: string) => {
    setInfractionsState({ ...infractionsVehicles, [key]: value });
  };

  useEffect(() => {
    setInfractionsState(infractionsVehicles);
  }, [infractionsVehicles]);

  return (
    <Box className={classes.sectionContainer}>
      <Typography variant="h6">Total de Infrações e Veículos Autuados</Typography>
      <Grid container xl={12} spacing={2}>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label}>Total de Infrações</InputLabel>
          <input
            name="Total de Infrações"
            type="number"
            min={0}
            className={classes.input}
            value={infractionsState['Total de Infrações']}
            onChange={(event) => {
              handleChange('Total de Infrações', event.target.value);
            }}
            onBlur={() => setInfractionsVehicles(infractionsState)}
          />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label}>Total de Veículos Autuados</InputLabel>
          <input
            name="Total de Veículos Autuados"
            type="number"
            min={0}
            className={classes.input}
            value={infractionsState['Total de Veículos Autuados']}
            onChange={(event) => {
              handleChange('Total de Veículos Autuados', event.target.value);
            }}
            onBlur={() => setInfractionsVehicles(infractionsState)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default InfrVehiclesFormGroup;
